var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import 'rxjs/add/observable/of';
import { DataSourceUtils } from '../../../shared/utils/data-source-utils';
import { GetInvoicesAction } from './invoices.action';
import { getInvoicesListSelector, getInvoicesTotalSelector } from './invoices.reducer';
var InvoicesTableDataSource = /** @class */ (function (_super) {
    __extends(InvoicesTableDataSource, _super);
    function InvoicesTableDataSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoicesTableDataSource.prototype.update = function () {
        this.store.dispatch(new GetInvoicesAction());
    };
    InvoicesTableDataSource.prototype.onConnect = function () {
        return this.store.select(getInvoicesListSelector).withLatestFrom(this.store.select(getInvoicesTotalSelector));
    };
    return InvoicesTableDataSource;
}(DataSourceUtils));
export { InvoicesTableDataSource };
